<template>
  <div id="aboutSpeech">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <router-link tag="a" :to="{ name: 'AboutComponent'}">{{ $t('message.about') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.about-speech') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.about-speech') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
          <h2 class="title">{{ $t('message.tts-help-0') }}</h2>
          <p v-html="$t('message.tts-help-1')"></p>
          <h2 class="title">{{ $t('message.tts-help-2') }}</h2>
          <p v-html="$t('message.tts-help-3')"></p>
          <h2 class="title">{{ $t('message.tts-help-13') }}</h2>
          <p>{{ $t('message.tts-help-14') }}</p>
          <p>{{ $t('message.tts-help-16') }}</p>
          <p v-html="$t('message.tts-help-17')"></p>
          <h2 class="title">{{ $t('message.tts-help-18') }}</h2>
          <p v-html="$t('message.tts-help-19')"></p>
          <p v-html="$t('message.tts-help-20')"></p>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "AboutSpeechComponent",
   data() {
    return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>
